import React, { useState, useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { latestResources, categorySlug } from '../resources/resourceList';
import './Navigation.css';
import shieldLogo from '../../assets/shield_logo.png';
import workspaceVisibilityImg from '../../assets/home/workspace_visibility.png';
import globalThreatImg from '../../assets/nav/global_threat.png';
import runtimeGatewayImg from '../../assets/nav/runtimegateway.png';

const Navigation = () => {
  const [onDark, setOnDark] = useState(true);
  const [platformOpen, setPlatformOpen] = useState(false);
  const [resourcesOpen, setResourcesOpen] = useState(false);
  const [useCasesOpen, setUseCasesOpen] = useState(false);
  const navigate = useNavigate();
  const platformTimeout = React.useRef(null);
  const resourcesTimeout = React.useRef(null);
  const useCasesTimeout = React.useRef(null);

  const openPlatform = () => {
    clearTimeout(platformTimeout.current);
    setPlatformOpen(true);
  };
  const closePlatform = () => {
    platformTimeout.current = setTimeout(() => setPlatformOpen(false), 150);
  };
  const openResources = () => {
    clearTimeout(resourcesTimeout.current);
    setResourcesOpen(true);
  };
  const closeResources = () => {
    resourcesTimeout.current = setTimeout(() => setResourcesOpen(false), 150);
  };
  const openUseCases = () => {
    clearTimeout(useCasesTimeout.current);
    setUseCasesOpen(true);
  };
  const closeUseCases = () => {
    useCasesTimeout.current = setTimeout(() => setUseCasesOpen(false), 150);
  };

  useEffect(() => {
    const handleScroll = () => {
      const navBottom = 60;
      const hero = document.querySelector('.main-hero');
      const dark = document.querySelector('.section-dark');
      const runtimeContent = document.querySelector('.runtime-content');
      let dark_ = false;
      if (hero) {
        const heroRect = hero.getBoundingClientRect();
        if (heroRect.top < navBottom && heroRect.bottom > navBottom) {
          dark_ = true;
        }
      }
      if (dark) {
        const darkRect = dark.getBoundingClientRect();
        if (darkRect.top < navBottom && darkRect.bottom > navBottom) {
          dark_ = true;
        }
      }
      if (runtimeContent) {
        const rcRect = runtimeContent.getBoundingClientRect();
        if (rcRect.top < navBottom && rcRect.bottom > navBottom) {
          dark_ = true;
          const lightSections = document.querySelectorAll('.runtime-section-light');
          lightSections.forEach(el => {
            const r = el.getBoundingClientRect();
            if (r.top < navBottom && r.bottom > navBottom) dark_ = false;
          });
        }
      }
      const ptContent = document.querySelector('.pt-content');
      if (ptContent) {
        const ptRect = ptContent.getBoundingClientRect();
        if (ptRect.top < navBottom && ptRect.bottom > navBottom) {
          dark_ = true;
          const lightSections = document.querySelectorAll('.pt-section-light');
          lightSections.forEach(el => {
            const r = el.getBoundingClientRect();
            if (r.top < navBottom && r.bottom > navBottom) dark_ = false;
          });
        }
      }
      const wsContent = document.querySelector('.ws-content');
      if (wsContent) {
        const wsRect = wsContent.getBoundingClientRect();
        if (wsRect.top < navBottom && wsRect.bottom > navBottom) {
          dark_ = true;
          const lightSections = document.querySelectorAll('.ws-section-light');
          lightSections.forEach(el => {
            const r = el.getBoundingClientRect();
            if (r.top < navBottom && r.bottom > navBottom) dark_ = false;
          });
        }
      }
      const ucpContent = document.querySelector('.ucp-content');
      if (ucpContent) {
        const ucpRect = ucpContent.getBoundingClientRect();
        if (ucpRect.top < navBottom && ucpRect.bottom > navBottom) {
          dark_ = true;
          const lightSections = document.querySelectorAll('.ucp-section-light');
          lightSections.forEach(el => {
            const r = el.getBoundingClientRect();
            if (r.top < navBottom && r.bottom > navBottom) dark_ = false;
          });
        }
      }
      setOnDark(dark_);
    };
    window.addEventListener('scroll', handleScroll);
    handleScroll();
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <nav className={`navigation ${onDark ? 'nav-dark' : 'nav-light'}`}>
      <div className="nav-container">
        <div className="nav-logo" onClick={() => { navigate('/'); window.scrollTo(0, 0); }} style={{ cursor: 'pointer' }}>
          <img src={shieldLogo} alt="Bltz AI" className="logo-icon" />
          <span className="logo-text">Bltz AI</span>
        </div>
        
        <div className="nav-links">
          <div className={`nav-item nav-item-platform${platformOpen ? ' active' : ''}`} onMouseEnter={openPlatform} onMouseLeave={closePlatform}>
            <span>Platform</span>
            <svg className="dropdown-arrow" width="12" height="12" viewBox="0 0 12 12" fill="none">
              <path d="M3 4.5L6 7.5L9 4.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </div>
          
          <div className={`nav-item nav-item-resources${resourcesOpen ? ' active' : ''}`} onMouseEnter={openResources} onMouseLeave={closeResources} onClick={() => { setResourcesOpen(false); navigate('/resources'); window.scrollTo(0, 0); }} style={{ cursor: 'pointer' }}>
            <span>Research</span>
            <svg className="dropdown-arrow" width="12" height="12" viewBox="0 0 12 12" fill="none">
              <path d="M3 4.5L6 7.5L9 4.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </div>
          
          <div className={`nav-item nav-item-usecases${useCasesOpen ? ' active' : ''}`} onMouseEnter={openUseCases} onMouseLeave={closeUseCases} onClick={() => { setUseCasesOpen(false); navigate('/use-cases'); window.scrollTo(0, 0); }} style={{ cursor: 'pointer' }}>
            <span>Use Cases</span>
            <svg className="dropdown-arrow" width="12" height="12" viewBox="0 0 12 12" fill="none">
              <path d="M3 4.5L6 7.5L9 4.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </div>
          
          <div className="nav-item" onClick={() => { navigate('/company'); window.scrollTo(0, 0); }} style={{ cursor: 'pointer' }}>
            <span>Company</span>
          </div>
          <div className="nav-item" onClick={() => { navigate('/partner'); window.scrollTo(0, 0); }} style={{ cursor: 'pointer' }}>
            <span>Partners</span>
          </div>
        </div>
        
        <div className="nav-actions">
          <span className="sign-in" style={{ cursor: 'pointer' }} onClick={() => { navigate('/contact'); window.scrollTo(0, 0); }}>Contact Us</span>
          <button className="get-demo" onClick={() => { navigate('/book-demo'); window.scrollTo(0, 0); }}>Book a Demo</button>
        </div>

        {resourcesOpen && (
          <div className="resources-dropdown" onMouseEnter={openResources} onMouseLeave={closeResources}>
            <div className="resources-dropdown-inner">
              <div className="resources-left">
                <img src={globalThreatImg} alt="AI Threat Landscape" className="resources-thumb" draggable="false" onContextMenu={e => e.preventDefault()} onDragStart={e => e.preventDefault()} />
                <div className="resources-flow">
                  <span>Blogs</span>
                  <span className="resources-flow-arrow">&bull;</span>
                  <span>Whitepapers</span>
                  <span className="resources-flow-arrow">&bull;</span>
                  <span>Case Studies</span>
                </div>
              </div>
              <div className="resources-right">
                {latestResources.map((card) => (
                  <Link key={card.slug} to={`/resources/${card.slug}`} className="platform-card" onClick={() => { setResourcesOpen(false); window.scrollTo(0, 0); }}>
                    <span className={`nav-cat-badge nav-cat-badge--${categorySlug(card.category)}`}>{card.category}</span>
                    <h4>{card.navTitle || card.title}</h4>
                    <p>{card.navDesc || card.desc}</p>
                  </Link>
                ))}
              </div>
              <div className="resources-view-all">
                <Link to="/resources" onClick={() => { setResourcesOpen(false); window.scrollTo(0, 0); }}>View All Research &rarr;</Link>
              </div>
            </div>
          </div>
        )}

        {useCasesOpen && (
          <div className="usecases-dropdown" onMouseEnter={openUseCases} onMouseLeave={closeUseCases}>
            <div className="usecases-dropdown-inner">
              <div className="usecases-left">
                <img src={runtimeGatewayImg} alt="AI Use Cases" className="usecases-thumb" draggable="false" onContextMenu={e => e.preventDefault()} onDragStart={e => e.preventDefault()} />
                <div className="usecases-flow">
                  <span>Banking</span>
                  <span className="usecases-flow-arrow">&bull;</span>
                  <span>Legal</span>
                  <span className="usecases-flow-arrow">&bull;</span>
                  <span>Medical</span>
                  <span className="usecases-flow-arrow">&bull;</span>
                  <span>Hospitality</span>
                </div>
              </div>
              <div className="usecases-right">
                <Link to="/use-cases/banking" className="platform-card" onClick={() => { setUseCasesOpen(false); window.scrollTo(0, 0); }}>
                  <h4>Banking &amp; Financial Services</h4>
                  <p>Runtime protection for AI-powered banking applications against prompt injection and data exfiltration.</p>
                </Link>
                <Link to="/use-cases/legal" className="platform-card" onClick={() => { setUseCasesOpen(false); window.scrollTo(0, 0); }}>
                  <h4>Legal Services</h4>
                  <p>Continuous purple team testing for AI legal assistants handling privileged and confidential data.</p>
                </Link>
                <Link to="/use-cases/medical" className="platform-card" onClick={() => { setUseCasesOpen(false); window.scrollTo(0, 0); }}>
                  <h4>Medical &amp; Healthcare</h4>
                  <p>AI governance and PHI protection for healthcare systems under HIPAA and HITECH compliance.</p>
                </Link>
                <Link to="/use-cases/hospitality" className="platform-card" onClick={() => { setUseCasesOpen(false); window.scrollTo(0, 0); }}>
                  <h4>Hospitality &amp; Travel</h4>
                  <p>Full-platform AI security for guest data protection and multi-region compliance.</p>
                </Link>
              </div>
              <div className="usecases-view-all">
                <Link to="/use-cases" onClick={() => { setUseCasesOpen(false); window.scrollTo(0, 0); }}>View All Use Cases &rarr;</Link>
              </div>
            </div>
          </div>
        )}

        {platformOpen && (
          <div className="platform-dropdown" onMouseEnter={openPlatform} onMouseLeave={closePlatform}>
            <div className="platform-dropdown-inner">
              <div className="platform-left">
                <img src={workspaceVisibilityImg} alt="Bltz AI Platform" className="platform-thumb" draggable="false" onContextMenu={e => e.preventDefault()} onDragStart={e => e.preventDefault()} />
                <div className="platform-flow">
                  <span>Discover</span>
                  <span className="platform-flow-arrow">→</span>
                  <span>Prevent</span>
                  <span className="platform-flow-arrow">→</span>
                  <span>Detect</span>
                  <span className="platform-flow-arrow">→</span>
                  <span>Remediate</span>
                </div>
              </div>
              <div className="platform-right">
                <div className="platform-card" onClick={() => { setPlatformOpen(false); navigate('/runtime-shield'); setTimeout(() => { const el = document.getElementById('section-discovery'); if (el) { const y = el.getBoundingClientRect().top + window.scrollY - 120; window.scrollTo({ top: y, behavior: 'smooth' }); } }, 200); }} style={{ cursor: 'pointer' }}>
                  <h4>Visibility</h4>
                  <p>Gain visibility into AI assets across environments to eliminate shadow AI.</p>
                </div>
                <Link to="/runtime-shield" className="platform-card platform-card--featured" onClick={() => { setPlatformOpen(false); window.scrollTo(0, 0); }}>
                  <h4>Runtime Shield</h4>
                  <p>Complete visibility and protection for AI in production, stopping prompt attacks, data leaks, and unsafe behavior.</p>
                </Link>
                <Link to="/purple-team" className="platform-card platform-card--featured" onClick={() => { setPlatformOpen(false); window.scrollTo(0, 0); }}>
                  <h4>Purple Team</h4>
                  <p>Continuous agentic AI risk testing and remediation, combining offensive and defensive AI agents.</p>
                </Link>
                <Link to="/ai-governance" className="platform-card platform-card--featured" onClick={() => { setPlatformOpen(false); window.scrollTo(0, 0); }}>
                  <h4>AI Governance</h4>
                  <p>Visibility, policy enforcement, and compliance reporting for how employees and teams use AI tools.</p>
                </Link>
              </div>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navigation;
